import { IFinanceDocuments } from '../../../types';
export type IFinanceDocumentState = IFinanceDocuments

export enum EmploymentStatus {
  COMPANY_EMP = 'Employed by a company/business',
  SELF_EMP = 'Self-Employed',
  WITHIN_5_YRS_EMP = 'Employed within the past 5 years',
  OVER_5_YRS_EMP = 'Employed over 5 years ago',
  NEVER_EMP = 'Never employed',
  RETIED = 'Retired'
}

export enum DocActionTypes {
  ADD_REQUIRED_DOCUMENT = '@@student/finance_documents/ADD_REQUIRED_DOCUMENT',
  ADD_REQUIRED_DOCUMENT_SUCCESS = '@@student/finance_documents/ADD_REQUIRED_DOCUMENT_SUCCESS',
  ADD_REQUIRED_DOCUMENT_FAILURE = '@@student/finance_documents/ADD_REQUIRED_DOCUMENT_FAILURE',
  SAVE_METADATA_FOR_NO_DOC = '@@visa/finance/SAVE_METADATA_FOR_NO_DOC',
  SAVE_METADATA_FOR_NO_DOC_SUCCESS = '@@visa/finance_documents/SAVE_METADATA_FOR_NO_DOC_SUCCESS',
  SAVE_METADATA_FOR_NO_DOC_FAILURE = '@@visa/finance_documents/SAVE_METADATA_FOR_NO_DOC_FAILURE',
  TOGGLE_ACKNOWLEDGE_DOC = '@@student/finance_documents/TOGGLE_ACKNOWLEDGE_DOC',
  TOGGLE_ACKNOWLEDGE_DOC_SUCCESS = '@@student/finance_documents/TOGGLE_ACKNOWLEDGE_DOC_SUCCESS',
  TOGGLE_ACKNOWLEDGE_DOC_FAILURE = '@@student/finance_documents/TOGGLE_ACKNOWLEDGE_DOC_FAILURE'
}
